(function () {

 'use strict';

  angular.module('eclipseApp.core').filter('maskCCNumber', ['$filter', function($filter) {
    return function(text) {
    if(text != null){
      var length = text.length ;
      if (length == 15){
        var number = text.substr(11);
        var tempCard = 'XXXX XXXX XXX ' + number;
      }
      if (length == 4) {
        var tempCard = '**** **** **** ' + text;
      }
      else{
        var number = text.substr(12);
        var tempCard = 'XXXX XXXX XXXX ' + number;
      }

      return (tempCard);
  }
}
  }]);

})();
